import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-balearic-popup',
  standalone: true,
  imports: [NgIf],
  templateUrl: './balearic-popup.component.html',
  styleUrl: './balearic-popup.component.css'
})
export class BalearicPopupComponent {
  @Input() show: boolean = false;
  @Input() imageSrc: string = '';
  @Output() closed = new EventEmitter<void>();

  close() {
    this.closed.emit();
  }
}
